/* @flow */
// first because it patches runtime env
import 'polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import Config from 'Config';
import * as zopim from 'lib/zopimListener';
import { AppContainer } from 'react-hot-loader';

import AppActions from 'actions/AppActions';
import { promiseDataIfSignedIn } from 'promises/userBootData';
import { registerInterceptor } from 'singletons/xhrInterceptors';
import { serviceUnavailableInterceptor } from 'lib/ResponseInterceptors';
import store from './reduxStore';

import Root from 'main/Root.jsx';

import './styles/app.scss';

if (__DEV__) {
  require('utils/setupPerfUtils');
}

if (window.trackJs) {
  // https://trackjs.com/blog/unhandled-promises/
  window.addEventListener('unhandledrejection', function (event) {
    const info = ('reason' in event) ? event.reason : event;
    window.trackJs.track(info);
  });
}

zopim.listenForStatusChange(store.dispatch);

__webpack_public_path__ = Config.Environment.PUBLIC_PATH; // eslint-disable-line

registerInterceptor('503-interceptor', serviceUnavailableInterceptor);

promiseDataIfSignedIn().then(() => {
  AppActions.observeConnection();

  const container = document.getElementById('app');

  ReactDOM.render((
    <AppContainer>
      <Root />
    </AppContainer>
  ), container);

  if (module.hot) {
    // $FlowFixMe Flow doesn't know about `module`
    module.hot.accept('main/Root.jsx', () => {
      // TODO make hot reloading work for reducers: https://github.com/gaearon/redux-devtools/blob/master/examples/counter/src/store/configureStore.dev.js
      const NextRoot = require('main/Root.jsx').default;
      ReactDOM.render((
        <AppContainer>
          <NextRoot />
        </AppContainer>
      ), container);
    });
  }
})
.catch(error => {
  console.error('Application failed to load:', error.stack ? error.stack : error);
  // TODO: Pretty failure
  throw error;
});



// WEBPACK FOOTER //
// ./src/app.js